import { fetchReportTypes, executeReport } from './financialReportService'

const state = {
  financialReportTypes: [],
  financialReportRows: [],
  isFinancialReportLoading: false,
}

const getters = {
  financialReportTypes: (state) => state.financialReportTypes,
  financialReportRows: (state) => state.financialReportRows,
  isFinancialReportLoading: (state) => state.isFinancialReportLoading,
}

const actions = {
  async fetchFinancialReportTypes({ commit, dispatch }) {
    try {
      const { data } = await fetchReportTypes()
      commit('setFinancialReportTypes', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data?.message)
    }
  },

  async executeFinancialReport({ commit, dispatch }, { type, date }) {
    commit('setIsFinancialReportLoading', true)
    commit('setFinancialReportRows', [])
    try {
      const { data } = await executeReport(type, date)
      commit('setFinancialReportRows', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data?.message)
    } finally {
      commit('setIsFinancialReportLoading', false)
    }
  },
}

const mutations = {
  setFinancialReportTypes: (state, types) => { state.financialReportTypes = types },
  setFinancialReportRows: (state, rows) => { state.financialReportRows = rows },
  setIsFinancialReportLoading: (state, value) => { state.isFinancialReportLoading = value },
}

export default { state, getters, actions, mutations }
